import { render, staticRenderFns } from "./FiatLinkView.vue?vue&type=template&id=a5a56954&scoped=true&"
import script from "./FiatLinkView.vue?vue&type=script&lang=ts&"
export * from "./FiatLinkView.vue?vue&type=script&lang=ts&"
import style0 from "./FiatLinkView.vue?vue&type=style&index=0&id=a5a56954&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a56954",
  null
  
)

export default component.exports